import { CHAIN_IDS, SupportedChainId } from '@/constants/chain';

import * as abstract from '../../../../public/images/chains/abstract.svg';
import * as arb from '../../../../public/images/chains/arbitrum.svg';
import * as arc from '../../../../public/images/chains/arc.svg';
import * as avax from '../../../../public/images/chains/avax.svg';
import * as base from '../../../../public/images/chains/base.svg';
import * as bsc from '../../../../public/images/chains/bsc.svg';
import * as eth from '../../../../public/images/chains/eth.svg';
import * as hyperevm from '../../../../public/images/chains/hyperevm.svg';
import * as ink from '../../../../public/images/chains/ink.svg';
import * as linea from '../../../../public/images/chains/linea.svg';
import * as mantle from '../../../../public/images/chains/mantle.svg';
import * as matic from '../../../../public/images/chains/matic.svg';
import * as monad from '../../../../public/images/chains/monad.svg';
import * as optimism from '../../../../public/images/chains/optimism.svg';
import * as plasma from '../../../../public/images/chains/plasma.svg';
import * as robinhood from '../../../../public/images/chains/robinhood.svg';
import * as scroll from '../../../../public/images/chains/scroll.svg';
import * as solana from '../../../../public/images/chains/solana.svg';
import * as unichain from '../../../../public/images/chains/unichain.svg';

export const chainAvatarSvg: Record<SupportedChainId, string> = {
  [CHAIN_IDS.MAINNET]: eth.default.src,
  [CHAIN_IDS.MATIC]: matic.default.src,
  [CHAIN_IDS.BASE]: base.default.src,
  [CHAIN_IDS.BSC]: bsc.default.src,
  [CHAIN_IDS.AVALANCHE]: avax.default.src,
  [CHAIN_IDS.ARBITRUM]: arb.default.src,
  [CHAIN_IDS.OPTIMISM]: optimism.default.src,
  [CHAIN_IDS.SCROLL]: scroll.default.src,
  [CHAIN_IDS.LINEA]: linea.default.src,
  [CHAIN_IDS.MANTLE]: mantle.default.src,
  [CHAIN_IDS.SOLANA]: solana.default.src,
  [CHAIN_IDS.UNICHAIN]: unichain.default.src,
  [CHAIN_IDS.PLASMA]: plasma.default.src,
  [CHAIN_IDS.MONAD]: monad.default.src,
  [CHAIN_IDS.ABSTRACT]: abstract.default.src,
  [CHAIN_IDS.HYPEREVM]: hyperevm.default.src,
  [CHAIN_IDS.ROBINHOOD]: robinhood.default.src,
  [CHAIN_IDS.INK]: ink.default.src,
  [CHAIN_IDS.ARC]: arc.default.src,
};

export const chainAvatarPng: Record<SupportedChainId, string> = {
  [CHAIN_IDS.MAINNET]: '/images/chains/eth.png',
  [CHAIN_IDS.MATIC]: '/images/chains/matic.png',
  [CHAIN_IDS.BASE]: '/images/chains/base.png',
  [CHAIN_IDS.BSC]: '/images/chains/bsc.png',
  [CHAIN_IDS.AVALANCHE]: '/images/chains/avax.png',
  [CHAIN_IDS.ARBITRUM]: '/images/chains/arbitrum.png',
  [CHAIN_IDS.OPTIMISM]: '/images/chains/optimism.png',
  [CHAIN_IDS.SCROLL]: '/images/chains/scroll.png',
  [CHAIN_IDS.LINEA]: '/images/chains/linea.png',
  [CHAIN_IDS.MANTLE]: '/images/chains/mantle.png',
  [CHAIN_IDS.SOLANA]: '/images/chains/solana.png',
  [CHAIN_IDS.UNICHAIN]: '/images/chains/unichain.png',
  [CHAIN_IDS.PLASMA]: '/images/chains/plasma.png',
  [CHAIN_IDS.MONAD]: '/images/chains/monad.png',
  [CHAIN_IDS.ABSTRACT]: '/images/chains/abstract.png',
  [CHAIN_IDS.HYPEREVM]: '/images/chains/hyperevm.png',
  [CHAIN_IDS.ROBINHOOD]: '/images/chains/robinhood.png',
  [CHAIN_IDS.INK]: '/images/chains/ink.png',
  [CHAIN_IDS.ARC]: '/images/chains/arc.png',
};
